import React from 'react';
import { TableRowSubItems } from '../TableRowSubItems/TableRowSubItems';
import { Props } from '../../interfaces/GenericTableRowDataProps';
import { Table } from 'semantic-ui-react';

export const SubItemsRow = <TData, TField, TDataSubItem = TData>(
  props: Props<TData, TField, TDataSubItem>,
  isItemHasSubItems: boolean | '' | undefined,
  isSubItemsOpened: boolean
) => {
  if (!isItemHasSubItems || !isSubItemsOpened || !props.keyNameSubItemsProperty)
    return null;

  return props.expandableRowContent ? (
    <Table.HeaderCell
      colSpan={props.columnDefinitions.length + (props.actions ? 2 : 1)}
      data-testid="p-os-expandable-row-content"
    >
      <div className="expandable-row-content">
        {props.expandableRowContent(
          (props.item as any)[props.keyNameSubItemsProperty]
        )}
      </div>
    </Table.HeaderCell>
  ) : (
    <TableRowSubItems
      getId={props.getId}
      items={
        (props.item as any)[props.keyNameSubItemsProperty] as TDataSubItem[]
      }
      columnDefinitionsLength={props.columnDefinitions.length}
      isMainRowHasActions={props.actions !== undefined}
      columnDefinitionsSubItem={props.columnDefinitionsSubItem ?? []}
      actions={props.actionsSubItems}
      showCheckButton={props.showCheckButton}
      showArrowForRowWithSubItems={props.showArrowForRowWithSubItems}
      showTableHeadForSubItems={props.showTableHeadForSubItems}
    />
  );
};
